//======> Docementation <== ====//
registerBlockType("tornado/aboutus-section3", {
  title: __("About Us Third Section", "tornado"),
  description: __("عن الشركة الجزء الثالث", "tornado"),
  icon: "feedback",
  category: "tornado",
  keywords: ["tornado", "section"],
  supports: {
    align: ["full", "wide"],
  },
  attributes: {
    featImgAbout: {
      type: "string",
      default: null,
    },
    head: {
      type: "string",
      default: "هذا عنوان مؤقت للمحتوي يقع هنا",
    },
    body: {
      type: "string",
      default:
        " هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى      ",
    },
    feats: {
      type: "string",
      default: "ميزة من مميزات الشركة",
    },
  },
  edit: (props) => {
    //==== Block Data ====//
    const { attributes, setAttributes } = props;
    props.setAttributes( { align: 'full' } );
    function onChangefeatImg(newIMG) {
      setAttributes({ featImgAbout: newIMG.sizes.full.url });
    }
    const set_head = (head) => {
      setAttributes({ head });
    };
    const set_body1 = (body) => {
      setAttributes({ body });
    };
    const set_feats = (feats) => {
      setAttributes({ feats });
    };
    return (
      <Panel>
        <InspectorControls style={{ marginBottom: "40px" }}>
          <PanelBody>
            <p>Select The Image For Background !</p>
            <MediaUpload
              onSelect={onChangefeatImg}
              value={attributes.featImgAbout}
              type="image"
              render={({ open }) => (
                <IconButton icon="upload" onClick={open}>
                  Upload Image!{" "}
                </IconButton>
              )}
            />
                          <div className="section-medium hero-section ">

<img src= {attributes.featImgAbout} />

</div>
          </PanelBody>
        </InspectorControls>
        <div class="section-small hero-section">
          <div class="container">
            <div class="row align-center-y overflow">
              <div
                class="col-12 col-l-6 media-col view-status"
                data-animation="fadeInEnd"
              >
                <a
                  href="#"
                  class="media-element responsive-element hd-size round-box"
                  data-src={attributes.featImgAbout}
                ></a>
              </div>
              <div
                class="col-12 col-l-6 content view-status"
                data-animation="fadeInStart"
              >
                <RichText
                  tagName="h2"
                  className="primary-color mb10"
                  value={attributes.head}
                  onChange={set_head}
                />
                <RichText
                  tagName="p"
                  value={attributes.body}
                  onChange={set_body1}
                />{" "}
                <div class="checklist arrow-icons">
                  <RichText
                    // tagName="ul"
                    multiline="li"
                    key="editable"
                    placeholder="عنوان قائمة نقاط كميزة مثلا"
                    value={attributes.feats}
                    onChange={set_feats}
                    keepPlaceholderOnFocus={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>
    );
  },
  save({ attributes }) {
    return (
      <div class="section-small hero-section">
        <div class="container">
          <div class="row align-center-y overflow">
            <div
              class="col-12 col-l-6 media-col view-status"
              data-animation="fadeInEnd"
            >
              <a
                href="#"
                class="media-element responsive-element hd-size round-box"
                data-src={attributes.featImgAbout}
              ></a>
            </div>
            <div
              class="col-12 col-l-6 content view-status"
              data-animation="fadeInStart"
            >
              <h2 class="primary-color mb10">{attributes.head}</h2>
              <p>{attributes.body}</p>
              <ul class="checklist arrow-icons">
                <RichText.Content multiline="li" value={attributes.feats} />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
